<span *ngIf="validationMessage" style="color: red" class="mb-2">{{ validationMessage }}</span>
<br *ngIf="validationMessage" />
<div style="display: flex; align-items: center; gap: 0.5rem;">
  <p-button
    [type]="type"
    [icon]="icon"
    [label]="label"
    [styleClass]="styleClass"
    [disabled]="isSubmitting"
    [pTooltip]="tooltip"
  ></p-button>
  <span *ngIf="isSubmitting" style="margin-left: 0.5rem; display: flex; align-items: center;">
    <i class="pi pi-spin pi-spinner" style="font-size: 1.5em;"></i>
    <button
      type="button"
      (click)="onCancel()"
      style="background: none; border: none; color: #888; margin-left: 0.5rem; 
			       cursor: pointer; font-size: 1.2em; display: flex; align-items: center;"
      title="Cancel validation"
			aria-label="Cancel"
    >
      <i class="pi pi-times"></i>
    </button>
  </span>
</div>